import styled from 'styled-components';
import { rem } from 'polished';
import iconImage from './images/icon.png';
import { prefix } from '../../tools/settings';
var HelpCallout = styled.div.withConfig({
  displayName: "HelpCalloutstyles__HelpCallout",
  componentId: "sc-xoaiyn-0"
})(["position:relative;background:var(--dentsu-color-y50);border:1px solid var(--dentsu-color-y300);border-radius:", ";padding:", ";margin-bottom:", ";&.", "-help-callout--icon{padding:", " ", " ", " ", ";&:before{position:absolute;left:20px;top:16px;content:'';background:url(", ");background-size:contain;display:block;width:", ";height:", ";}}"], rem(6), rem(20), rem(16), prefix, rem(20), rem(20), rem(20), rem(64), iconImage, rem(32), rem(32));
var HelpCalloutTitle = styled.h2.withConfig({
  displayName: "HelpCalloutstyles__HelpCalloutTitle",
  componentId: "sc-xoaiyn-1"
})(["font-size:var(--dentsu-font-size-16);font-weight:var(--dentsu-font-weight-semibold);&:empty{display:none;}"]);
var HelpCalloutContent = styled.div.withConfig({
  displayName: "HelpCalloutstyles__HelpCalloutContent",
  componentId: "sc-xoaiyn-2"
})(["margin-top:", ";font-size:var(--dentsu-font-size-12);line-height:", ";&:empty{display:none;}* + *{margin-top:", ";}*{font-size:var(--dentsu-font-size-12);line-height:", ";}"], rem(4), rem(16), rem(12), rem(16));
export var Styled = {
  HelpCallout: HelpCallout,
  HelpCalloutTitle: HelpCalloutTitle,
  HelpCalloutContent: HelpCalloutContent
};